import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import plusKnockoutTokens from '@amzn/meridian-tokens/base/icon/plus-knockout';
import { StateContext } from '../../GlobalStateStore';

export interface CreateGoalButtonProps {
  onOpen: any;
  page: string;
  username: string; // displayed user name
}

const CreateGoalButton: React.FC<CreateGoalButtonProps> = ({
  onOpen,
  page,
  username,
}: CreateGoalButtonProps): React.ReactElement => {
  const globalState = useContext(StateContext);
  const { inspireOptions } = globalState.state;
  const { isTm, requesterUserID, requesterUsername } = inspireOptions.data;

  return (
    <>
      <Button
        data-csa-c-type='button'
        data-csa-c-slot-id={`${page}-goal-setting-create-goal-button`}
        data-csa-c-content-id={`${page}-goal-setting-create-goal-button-for-${username}`}
        data-csa-c-tag1={page}
        data-csa-c-tag2='Goal Setting'
        data-csa-c-profile-id={requesterUserID}
        data-csa-c-username={requesterUsername}
        data-csa-c-is-tm={isTm}
        onClick={onOpen}
        data-testid='create-a-new-goal'
        type='tertiary'
      >
        <Icon tokens={plusKnockoutTokens} />{' '}
        <FormattedMessage
          id='cs_perfportal_goals_create_a_new_goal'
          defaultMessage='Create a New Goal'
        />
      </Button>
    </>
  );
};

export default CreateGoalButton;
